import { useInfiniteQuery } from "@tanstack/react-query";
import {
  tracksControllerTracksList,
  getTracksControllerTracksListQueryKey,
} from "@/lib/lutely-api/gen/tracks/tracks";
import type { TracksControllerTracksListParams } from "@/lib/lutely-api/gen/dtos";

type UseTracksInfiniteListParams = Omit<
  TracksControllerTracksListParams,
  "pageNumber"
>;

export function useTracksInfiniteList(
  params: UseTracksInfiniteListParams,
  options: {
    enabled?: boolean;
  } = {},
) {
  return useInfiniteQuery({
    queryKey: getTracksControllerTracksListQueryKey(params),
    queryFn: ({ pageParam }) =>
      tracksControllerTracksList({
        ...params,
        pageNumber: pageParam,
      }),
    getNextPageParam: (lastPage) => lastPage.nextPage,
    initialPageParam: 0,
    ...options,
  });
}
